define("calendar/components/calendar/stories/thumbnails", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object/computed", "@ember/service", "@ember/object", "ember-concurrency-decorators"], function (_exports, _component, _templateFactory, _component2, _computed, _service, _object, _emberConcurrencyDecorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object/computed",0,"@ember/service",0,"@ember/object",0,"ember-concurrency-decorators",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <span class="u--inline">
    <DragSortList
      @items={{this.orderedPostMediaItems}}
      @isHorizontal={{true}}
      @dragEndAction={{perform this.updateOrder}} as |postMediaItem|
    >
      <Calendar::Stories::SortableItem
        @item={{postMediaItem}}
        @groupId={{@groupId}}
        @storyVideoMaxLength={{@storyVideoMaxLength}}
        @canCropOnPost={{@canCropOnPost}}
        @canDeleteStoryItems={{@canDeleteStoryItems}}
        @removeStoryItem={{fn this.removeStoryItem postMediaItem}}
        @editPMICrop={{fn @editPMICrop postMediaItem}}
      />
    </DragSortList>
  </span>
  
  */
  {
    "id": "TNQMhhdV",
    "block": "[[[10,1],[14,0,\"u--inline\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@items\",\"@isHorizontal\",\"@dragEndAction\"],[[30,0,[\"orderedPostMediaItems\"]],true,[28,[37,1],[[30,0,[\"updateOrder\"]]],null]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,2],null,[[\"@item\",\"@groupId\",\"@storyVideoMaxLength\",\"@canCropOnPost\",\"@canDeleteStoryItems\",\"@removeStoryItem\",\"@editPMICrop\"],[[30,1],[30,2],[30,3],[30,4],[30,5],[28,[37,3],[[30,0,[\"removeStoryItem\"]],[30,1]],null],[28,[37,3],[[30,6],[30,1]],null]]],null],[1,\"\\n  \"]],[1]]]]],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"postMediaItem\",\"@groupId\",\"@storyVideoMaxLength\",\"@canCropOnPost\",\"@canDeleteStoryItems\",\"@editPMICrop\"],false,[\"drag-sort-list\",\"perform\",\"calendar/stories/sortable-item\",\"fn\"]]",
    "moduleName": "calendar/components/calendar/stories/thumbnails.hbs",
    "isStrictMode": false
  });

  let ThumbnailsComponent = (_dec = (0, _computed.sort)('args.postMediaItems', 'postMediaItemsSorting'), (_class = class ThumbnailsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "segment", _descriptor, this);

      _defineProperty(this, "postMediaItemsSorting", ['ordering']);

      _initializerDefineProperty(this, "orderedPostMediaItems", _descriptor2, this);
    }

    removeStoryItem(item) {
      if (this.args.canDeleteStoryItems) {
        item.set('isRemoved', true);
        const removedOrdering = parseInt(item.get('ordering'));
        const orderedItems = this.orderedPostMediaItems;

        for (let i = removedOrdering; i < orderedItems.length; i++) {
          const postMediaItem = orderedItems.objectAt(i);
          const currentOrdering = postMediaItem === null || postMediaItem === void 0 ? void 0 : postMediaItem.get('ordering');
          postMediaItem === null || postMediaItem === void 0 ? void 0 : postMediaItem.set('ordering', currentOrdering - 1);
        }

        this.args.deleteStoryItem(item);
      }
    }

    *updateOrder(_ref2) {
      let {
        sourceList,
        sourceIndex,
        targetIndex,
        targetList
      } = _ref2;

      if (sourceList === targetList && sourceIndex === targetIndex) {
        return;
      }

      const item = sourceList.objectAt(sourceIndex);

      if (!item) {
        return;
      }

      yield sourceList.removeAt(sourceIndex);
      yield targetList.insertAt(targetIndex, item);
      this.updatePMISorting(targetList);
    }

    updatePMISorting(newlySortedList) {
      newlySortedList.forEach((item, sortIndex) => {
        item.set('ordering', sortIndex);
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "orderedPostMediaItems", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "removeStoryItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeStoryItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateOrder", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "updateOrder"), _class.prototype)), _class));
  _exports.default = ThumbnailsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ThumbnailsComponent);
});